
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.88 22c.626 0 1.12-.39 1.12-1.322V3.208C16 1.075 14.96 0 12.873 0H3.127C1.04 0 0 1.076 0 3.207v17.471C0 21.611.494 22 1.12 22c.514 0 .797-.297 1.836-1.301l4.55-4.427c.222-.215.353-.277.494-.277.141 0 .272.072.494.277l5.145 5.041c.404.39.727.687 1.241.687z","fill":"#FFA01D","fill-rule":"nonzero"}})])
          )
        }
      }
    